function positiveMod(n, mod) {
  return ((n % mod) + mod) % mod;
}

function GetEracheDateComponents(date) {
  if (date == null || date === 0) return null;

  var h = date.getHours();
  var m = date.getMinutes();

  //Day 1 of Erache's calendar /!\ 0 is january, 11 is December
  var dateOrigin = new Date(2010, 10, 9, 0, 0);

  //Extract day, month and year from date
  var dateToExtract = new Date(date);
  var day = dateToExtract.getDate();
  var month = dateToExtract.getMonth();
  var year = dateToExtract.getFullYear();

  if (h == null) h = day % 24;
  if (m == null) m = (year + month + day) % 60;

  //Create date to convert
  var dateToConvert = new Date(year, month, day, h, m);

  //Number of ms between the two dates
  var timeDiff = dateToConvert.getTime() - dateOrigin.getTime();
  var diffDays = timeDiff / (1000 * 3600 * 24);

  /* 20min IRL = 1 day erache
    1h IRL    = 3 days erache
    24h IRL   = 72 days erache
  */
  //Number of Erache's days between the two dates
  var eracheDays = Math.floor(diffDays * 72);
  //Number of Erache's months between the two dates
  var eracheMonths = Math.floor(eracheDays / 64);
  //Number of Erache's years between the two dates
  var eracheYear = Math.floor(eracheDays / 1024);

  // Use positive modulo for day/month
  var eracheDay = positiveMod(eracheDays, 64) + 1;
  var eracheMonth = positiveMod(eracheMonths, 16) + 1;
  var months = EracheMonths;

  //Calculation of the month, there is 16 months in a year :
  var eracheMonthName = months[eracheMonth - 1];

  var daysOfWeek = [
    "Premui", "Dezui", "Tressui", "Khatui", "Quinui", "Sizui", "Sepui", "Houi"
  ];
  var dayOfWeek = (eracheDay - 1) % 8;
  var dayOfWeekName = daysOfWeek[dayOfWeek];

  return {
    day: eracheDay,
    month: eracheMonth,
    monthName: eracheMonthName,
    year: eracheYear,
    dayOfWeek,
    dayOfWeekName,
    isBeforeDok: timeDiff <= 0
  };
}

function DateIRLToErache(date, shouldDisplayDayOfWeekName) {
  const erache = GetEracheDateComponents(date);
  if (!erache) return "Date invalide";

  if (!erache.isBeforeDok) {
    if (shouldDisplayDayOfWeekName) {
      return (
        erache.dayOfWeekName +
        " " +
        erache.day +
        " " +
        erache.monthName +
        " de l'an " +
        erache.year
      );
    }
    return erache.day + " " + erache.monthName + " de l'an " + erache.year;
  } else {
    if (shouldDisplayDayOfWeekName) {
      return (
        erache.dayOfWeekName +
        " " +
        erache.day +
        " " +
        erache.monthName +
        " de l'an " +
        erache.year
      );
    }
    return erache.day + " " + erache.monthName + " de l'an " + erache.year;
  }
}

function AgeCalculator(date) {
  if (date == null || date === 0) {
    return "Date invalide";
  }
  var currentTime = new Date();

  // Number of ms between inscription and today
  // If the date is in the future, the result will be negative
  var timeDiff = currentTime.getTime() - date.getTime();

  // Number of RP days (20min) between the two dates
  var diffDays = timeDiff / (1000 * 60 * 20);

  // Special case for today
  if (timeDiff < 10 * 60 * 1000 && timeDiff > -10 * 60 * 1000) {
    return "Aujourd'hui";
  }

  var stringToReturn = "";
  var diffYears = Math.floor(diffDays / 1024);
  var diffMonths = Math.floor((diffDays % 1024) / 64);
  var diffFloorDays = Math.floor(diffDays % 64);
  if (timeDiff < 0) {
    // If the date is in the future
    stringToReturn = "(Dans ";
    diffYears = Math.floor((-diffDays + 1) / 1024);
    diffMonths = Math.floor(((-diffDays + 1) % 1024) / 64);
    diffFloorDays = Math.floor((-diffDays + 1) % 64);
  } else {
    // If the date is in the past
    stringToReturn = "(Il y a ";
  }

  if (diffYears !== 0) {
    if (diffYears === 1) {
      stringToReturn += diffYears + " an";
    } else {
      stringToReturn += diffYears + " ans";
    }
  }

  if (diffMonths !== 0) {
    if (diffYears !== 0) {
      stringToReturn += " et ";
    }
    stringToReturn += diffMonths + " mois";
  }

  if (diffFloorDays !== 0) {
    if (diffYears !== 0 || diffMonths !== 0) {
      stringToReturn += " et ";
    }
    // If there is only one day, we don't want to display "1 jours"
    if (diffFloorDays === 1) {
      stringToReturn += diffFloorDays + " jour";
    } else {
      stringToReturn += diffFloorDays + " jours";
    }
  }

  stringToReturn += ")";
  return stringToReturn;
}

function EracheToDateIRL(eracheYear, eracheMonth, eracheDay) {
  // Origine : 9 novembre 2010 à 00:00
  const dateOrigin = new Date(2010, 10, 9, 0, 0);

  // Calcul du nombre total de jours érachiens depuis l'origine
  const totalEracheDays = eracheYear * 1024 + (eracheMonth - 1) * 64 + (eracheDay - 1);

  // Conversion en millisecondes IRL (1 jour érachien = 20 min IRL)
  const msToAdd = totalEracheDays * 20 * 60 * 1000;

  // Calcul de la date IRL
  const irlDateFrom = new Date(dateOrigin.getTime() + msToAdd);

  return irlDateFrom;
}

function ParseEracheDateFromText(text) {
  // Cherche les nombres dans le texte
  const numbers = text.match(/\d+/g);
  // Cherche le mois (nom exact parmi la liste)
  const monthNames = EracheMonths.map(m => m.toLowerCase());
  const monthRegex = new RegExp(monthNames.join("|"), "i");
  const monthMatch = text.toLowerCase().match(monthRegex);

  if (!numbers || numbers.length < 2 || !monthMatch) {
    return null; // Parsing failed
  }

  // Heuristique : le premier nombre = jour, le second = année
  const day = parseInt(numbers[0], 10);
  const year = parseInt(numbers[1], 10);
  const month = monthNames.indexOf(monthMatch[0]) + 1;

  if (day < 1 || day > 64 || month < 1 || month > 16 || year < 0) {
    return null;
  }
  return { day, month, year };
}

const EracheMonths = [
  "Pampélune",
  "Fifrelune",
  "Mimélune",
  "Claircelune",
  "Mérolia",
  "Cidélia",
  "Iffélia",
  "Lérolia",
  "Holevent",
  "Agrevent",
  "Tercevent",
  "Démévent",
  "Radévard",
  "Tronvard",
  "Pénavard",
  "Nérévard",
];

/**
 * Single conversion from backend date to frontend Date. No guessing, no midnight normalization.
 * Backend is the source of truth; this only parses the ISO string.
 */
function apiDateToDate(apiDate) {
  if (apiDate == null) return null;
  const d = new Date(apiDate);
  return isNaN(d.getTime()) ? null : d;
}

function pad2(n) {
  return String(n).padStart(2, "0");
}

/** IRL calendar date only: YYYY-MM-DD (international). */
function formatIrlDate(apiDateOrDate) {
  const d = apiDateOrDate instanceof Date ? apiDateOrDate : apiDateToDate(apiDateOrDate);
  if (!d) return "";
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  return `${y}-${m}-${day}`;
}

/** IRL date and time to minute precision: YYYY-MM-DD HH:mm (international, local clock). */
function formatIrlDateTime(apiDateOrDate) {
  const d = apiDateOrDate instanceof Date ? apiDateOrDate : apiDateToDate(apiDateOrDate);
  if (!d) return "";
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  const h = pad2(d.getHours());
  const min = pad2(d.getMinutes());
  return `${y}-${m}-${day} ${h}:${min}`;
}

/** Same as formatIrlDateTime (kept for existing imports). */
const formatEventDateLocal = formatIrlDateTime;

export {
  DateIRLToErache,
  AgeCalculator,
  EracheToDateIRL,
  ParseEracheDateFromText,
  GetEracheDateComponents,
  EracheMonths,
  apiDateToDate,
  formatIrlDate,
  formatIrlDateTime,
  formatEventDateLocal,
};
